/**
 * 会员首页接口
 * 创建者: wangming
 * 创建日期: 2023-4-24
 */

import { uGet,uPost } from './http';

// 公开接口
// 获取优惠券权益列表
export const getCouponsList = (params) => {
    return uGet('/v1/point/rights/public/coupons', {params});
}

// 获取礼品卡权益列表
export const getGiftCardsList = (params) => {
    return uGet('/v1/point/rights/public/giftcards', {params});
}

// 获取 jackery 实物权益列表
export const getJackeryThingsList = (params) => {
    return uGet('/v1/point/rights/public/coupons/things', {params});
}

// 获取 虚拟卡权益列表（其他部分）
export const getVirtualCardsList = (params) => {
    return uGet("/v1/point/rights/public/virtualcards", {params})
}


// 获取站点账户权益积分
export const getRulePointAndIssueStatus = params => {
    return uGet("/v1/point/rights/public/getRulePointAndIssueStatus", {params})
}
// 获取个人当前站点账户积分，以及 是否发放过 邮件和短信订阅 的积分
export const getCustomerRulePointAndIssueStatus = params => {
    return uGet("/v1/point/rights/customer/getRulePointAndIssueStatus", {params})
}


// 需要鉴权的接口
// 兑换权益需要先登录鉴权
export const exchangeRight = (params) => {
    return uPost(`/v1/point/rights/customer/exchange?ruleId=${params.ruleId}&version=${params.version}` )
}

// 获取用户账户的积分余额
export const pullBalanceAmount =(params) => {
    return uGet("/v1/point/pointAccount")
}

// 获取用户可以兑换的权益，从小到大，优惠券
export const getCustomerCouponsList = (params) => {
    return uGet('/v1/point/rights/customer/coupons', {params});
}

// 获取用户可以兑换的权益，从小到大，实物优惠券
export const getCustomerCouponsThingList = (params) => {
    return uGet('/v1/point/rights/customer/coupons/things', {params});
}

// 获取用户可以兑换的权益，从小到大，礼品卡
export const getCustomerGiftcardList = (params) => {
    return uGet('/v1/point/rights/customer/giftcards', {params});
}

// 获取用户可以兑换的权益，从小到大，虚拟卡
export const getCustomerVirtualCardsList = (params) => {
    return uGet("/v1/point/rights/customer/virtualcards", {params})
}


// 已兑换 还未使用， 优惠券列表
export const getMyRewardsCoupons = (params) => {
    return uPost("/v1/point/myrewards/coupons/list", params)
}
// 已兑换 还未使用， 礼品卡列表
export const getMyRewardsGiftCard = (params) => {
    return uPost("/v1/point/myrewards/giftcards/list", params)
}
// 已兑换 还未使用， jackery 实物列表
export const getMyRewardsThings = (params) => {
    return uPost("/v1/point/myrewards/things/list", params)
}
// 已兑换 还未使用， 虚拟卡列表
export const getMyRewardsVirtualCard = (params) => {
    return uPost("/v1/point/myrewards/virtualcards/list", params)
}


// 查询目前公开可用的活动
export const getCampaignList = (params) => {
    return uGet("/v1/point-boot-campaign-customer/campaign-list", {params})
}


// 会员积分相关
// 获取账户存在积分的站点
export const getAccountPoint = params => {
    return uGet("/v1/point/pointShop", {params})
}

// 获取账户积分明细
export const getAccountPointsDetail = params => {
    return uGet("/v1/point/pointLog", {params})
}

// 获取兑换规则
export const ruleConfsite = (params) => {
    return uGet("/v1/point/rights/public/ruleConfiSite", {params})
}
